import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppStore from '../../stores/app-store';
import AppActions from '../../actions/app-actions';

import Preference from './preference';
import { AppContext } from '../../contexts/app-context';

const routes = {
  preference: {
    route: '/preferences/preference',
    status: 'preference',
    title: 'Preference'
  },
  history: {
    route: '/preferences/history',
    status: 'history',
    title: 'History'
  }
};

export default class Preferences extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();  
  }

  _getInitialState() {
    return {
      tabIndex: this._updateActive(),
      snackbar: AppStore.getSnackbar(),
      hasMultitenancy: AppStore.hasMultitenancy()
    };
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({ tabIndex: this._updateActive() });
  }

  _onChange() {
    this.setState(this._getInitialState());
  }

  _updateActive(tab = this.context.router.route.match.params.tab) {
    if (routes.hasOwnProperty(tab)) {
      return routes[tab].route;
    }
    return routes.preference.route;
  }

  _handleTabActive(tab) {
    var self = this;
    self.context.router.history.push(tab.props.value);
  }
  _changeTab(route) {
    var self = this;
    AppActions.setSnackbar('');
    self.context.router.history.push(route);
  }

  render() {

    const tabIndex = this.context.router.route.match.params.tab || 'preference';
    return (
      <div style={{ marginTop: '-15px' }}>
        <Tabs value={tabIndex} onChange={() => this._changeTab.bind(this)}>
          <Tab component={Link} label={routes.preference.title} value={routes.preference.status} to={routes.preference.route} />
          <Tab component={Link} label={routes.history.title} value={routes.history.status} to={routes.history.route} />
        </Tabs>
        <AppContext.Consumer>
          {({ globalSettings, docsVersion }) => (
            <div>
              {tabIndex === routes.preference.status && (
                <Preference 
                  docsVersion={docsVersion}
                  globalSettings={globalSettings}
                />
              )}
              {tabIndex === routes.history.status && (
                <h1 />
              )}
            </div>
          )}
        </AppContext.Consumer>
      </div>
    )
  }
}
